module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/~/pui-react-animation/~/babel-runtime/~/core-js/library/modules/$.is-object.js
 ** module id = 45
 ** module chunks = 0
 **/